import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="8" width="21" height="21" rx="3" stroke="#0090FF" strokeWidth="2" />
      <rect opacity="0.5" x="16" y="12" width="5" height="6" rx="2.5" stroke="#0090FF" strokeWidth="2" />
      <g opacity="0.5">
        <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="11" y="11" width="15" height="15">
          <rect x="11" y="11" width="15" height="15" rx="1" fill="#C4C4C4" />
        </mask>
        <g mask="url(#mask0)">
          <rect x="12" y="22" width="13" height="22" rx="4" stroke="#0090FF" strokeWidth="2" />
        </g>
      </g>
      <path
        opacity="0.5"
        d="M6 4H21C21.7403 4 22.3866 4.4022 22.7324 5H24.874C24.4299 3.27477 22.8638 2 21 2H6C3.79086 2 2 3.79086 2 6V21C2 22.8638 3.27477 24.4299 5 24.874V22.7324C4.4022 22.3866 4 21.7403 4 21V6C4 4.89543 4.89543 4 6 4Z"
        fill="#0090FF"
      />
    </svg>
  );
};

export default Svg;
